import { BASE_URL } from "@/constants/config";
import {request} from "@/utils/request";

export const CAMPAGNES_ENDPOINTS = {
  base: `${BASE_URL}api/campaigns/`,
  campaign: (id) => `${CAMPAGNES_ENDPOINTS.base}${id}/`,
  sendEmails: (id) => `${CAMPAGNES_ENDPOINTS.campaign(id)}send/`,
  export: (id) => `${CAMPAGNES_ENDPOINTS.campaign(id)}export/`,
  alumni: (id) => `${CAMPAGNES_ENDPOINTS.campaign(id)}alumni/`,
  duplicate: (id) => `${CAMPAGNES_ENDPOINTS.campaign(id)}duplicate/`,
};

class Campaign {
  async fetchCampaign(id){
    return await request({
      url: CAMPAGNES_ENDPOINTS.campaign(id),
    });
  }

  async updateCampaign(id, payload){
    return await request({
      url: CAMPAGNES_ENDPOINTS.campaign(id),
      method: "PATCH",
      body: payload,
    });
  }

  async deleteCampaign(id) {
    return await request({
      url: CAMPAGNES_ENDPOINTS.campaign(id),
      method: 'DELETE',
    });
  }

  async createCampaign(payload){
    return await request({
      url: CAMPAGNES_ENDPOINTS.base,
      method: "POST",
      body: payload,
    });
  }

  async sendEmails(id, payload) {
    return await request({
      url: CAMPAGNES_ENDPOINTS.sendEmails(id),
      body: payload,
      method: "POST",
    });
  }

  async fetchCampaignAlumni(id, query) {
    const { data } = await request({
      url: CAMPAGNES_ENDPOINTS.alumni(id),
      query,
    });
    return data;
  }

  async duplicateCampaign(id){
    return await request({
      url: CAMPAGNES_ENDPOINTS.duplicate(id),
      method: "POST",
    });
  }
}

export const CampaignService = new Campaign();
